import { render, staticRenderFns } from "./precalificacionesIncompletas.vue?vue&type=template&id=53b41c30&scoped=true"
import script from "./precalificacionesIncompletas.vue?vue&type=script&lang=js"
export * from "./precalificacionesIncompletas.vue?vue&type=script&lang=js"
import style0 from "./precalificacionesIncompletas.vue?vue&type=style&index=0&id=53b41c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b41c30",
  null
  
)

export default component.exports